interface IconProps {
    className?: string | null;
    animationClassName?: string | null;
}

function HeaderChessboard({ className = null, animationClassName = null }: IconProps) {
    return (
        <svg
            className={className || undefined}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1688 97"
        >
            <path d="M1149.18,72.12h-23.85v31.29h23.85v-31.29Z" />
            <path d="M1149.18,23.77h-23.85v24.59h23.85v-24.59Z" />
            <path d="M1172.22,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M1172.22,0h-23.04v23.77h23.04V0Z" />
            <path d="M1196.06,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1196.06,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1219.11,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1219.11,0h-23.05v23.77h23.05V0Z" />
            <path d="M1242.95,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1242.95,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1266,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1266,0h-23.05v23.77h23.05V0Z" />
            <path d="M1289.84,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1289.84,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1312.89,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1312.89,0h-23.05v23.77h23.05V0Z" />
            <path d="M1336.73,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1336.73,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1359.78,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1359.78,0h-23.05v23.77h23.05V0Z" />
            <path d="M1383.62,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1383.62,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1406.67,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1406.67,0h-23.05v23.77h23.05V0Z" />
            <path d="M1430.51,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1430.51,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1453.56,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1453.56,0h-23.05v23.77h23.05V0Z" />
            <path d="M1477.4,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1477.4,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1500.44,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M1500.44,0h-23.04v23.77h23.04V0Z" />
            <path d="M1524.29,72.12h-23.85v31.29h23.85v-31.29Z" />
            <path d="M1524.29,23.77h-23.85v24.59h23.85v-24.59Z" />
            <path d="M1547.33,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M1547.33,0h-23.04v23.77h23.04V0Z" />
            <path d="M1571.18,72.12h-23.85v31.29h23.85v-31.29Z" />
            <path d="M1571.18,23.77h-23.85v24.59h23.85v-24.59Z" />
            <path d="M1594.22,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M1594.22,0h-23.04v23.77h23.04V0Z" />
            <path d="M1618.06,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1618.06,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1641.11,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1641.11,0h-23.05v23.77h23.05V0Z" />
            <path d="M1664.95,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1664.95,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1688,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1688.45-.96h-23.5v24.73h23.5V-.96Z" />
            <path d="M23.84,72.12H-.16v31.67h24v-31.67Z" />
            <path d="M586.51,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M23.84,23.77H0v24.59h23.84v-24.59Z" />
            <path d="M586.51,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M46.89,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M609.56,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M46.89,0h-23.05v23.77h23.05V0Z" />
            <path d="M609.56,0h-23.05v23.77h23.05V0Z" />
            <path d="M70.73,72.12h-23.84v33.61h23.84v-33.61Z" />
            <path d="M633.4,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M70.73,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M633.4,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M93.78,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M656.44,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M93.78,0h-23.05v23.77h23.05V0Z" />
            <path d="M656.44,0h-23.05v23.77h23.05V0Z" />
            <path d="M117.62,72.12h-23.84v34.71h23.84v-34.71Z" />
            <path d="M680.29,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M117.62,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M680.29,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M140.67,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M703.33,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M140.67,0h-23.05v23.77h23.05V0Z" />
            <path d="M703.33,0h-23.05v23.77h23.05V0Z" />
            <path d="M164.51,72.12h-23.84v37.41h23.84v-37.41Z" />
            <path d="M727.17,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M164.51,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M727.17,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M187.56,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M750.22,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M187.56,0h-23.05v23.77h23.05V0Z" />
            <path d="M750.22,0h-23.05v23.77h23.05V0Z" />
            <path d="M211.4,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M774.06,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M211.4,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M774.06,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M234.44,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M797.11,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M234.44,0h-23.05v23.77h23.05V0Z" />
            <path d="M797.11,0h-23.05v23.77h23.05V0Z" />
            <path d="M258.29,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M820.95,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M258.29,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M820.95,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M281.33,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M844,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M281.33,0h-23.05v23.77h23.05V0Z" />
            <path d="M844,0h-23.05v23.77h23.05V0Z" />
            <path d="M305.17,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M867.84,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M305.17,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M867.84,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M328.22,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M890.89,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M328.22,0h-23.05v23.77h23.05V0Z" />
            <path d="M890.89,0h-23.05v23.77h23.05V0Z" />
            <path d="M352.06,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M914.73,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M352.06,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M914.73,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M375.11,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M937.78,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M375.11,0h-23.05v23.77h23.05V0Z" />
            <path d="M937.78,0h-23.05v23.77h23.05V0Z" />
            <path d="M398.95,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M961.62,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M398.95,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M961.62,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M422,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M984.67,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M422,0h-23.05v23.77h23.05V0Z" />
            <path d="M984.67,0h-23.05v23.77h23.05V0Z" />
            <path d="M445.84,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1008.51,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M445.84,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1008.51,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M468.89,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1031.56,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M468.89,0h-23.05v23.77h23.05V0Z" />
            <path d="M1031.56,0h-23.05v23.77h23.05V0Z" />
            <path d="M492.73,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1055.4,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M492.73,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1055.4,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M515.78,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1078.44,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M515.78,0h-23.05v23.77h23.05V0Z" />
            <path d="M1078.44,0h-23.04v23.77h23.04V0Z" />
            <path d="M539.62,72.12h-23.84v31.29h23.84v-31.29Z" />
            <path d="M1102.29,72.12h-23.85v31.29h23.85v-31.29Z" />
            <path d="M539.62,23.77h-23.84v24.59h23.84v-24.59Z" />
            <path d="M1102.29,23.77h-23.85v24.59h23.85v-24.59Z" />
            <path d="M562.67,48.35h-23.05v23.77h23.05v-23.77Z" />
            <path d="M1125.33,48.35h-23.04v23.77h23.04v-23.77Z" />
            <path d="M562.67,0h-23.05v23.77h23.05V0Z" />
            <path d="M1125.33,0h-23.04v23.77h23.04V0Z" />
        </svg>
    );
}

export default HeaderChessboard;
